package pwgs.ui.scenes.login

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(LoginSceneProps::class, LoginSceneModel::class)
interface Login {
    fun login(baseUrl: String)
}

@Serializable
class LoginSceneProps

@Serializable
class LoginSceneModel(
    val loginUrl: String?
)